<!--  -->
<template>
    <div class="business-content-main outconfirm-content">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div>
            <div class="search-ctn" style="min-height: 0">
                <div class="search-ctn-left">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询 (F2)</el-button>
                    <el-button v-if="permission.print && tableData.length > 0" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{
                        permission.print
                    }}</el-button>
                    <el-button v-if="permission.batchComfirm" size="small" type="warning" icon="el-icon-document-copy" class="search-btn" @click="batchComfirms()"
                        >{{ permission.batchComfirm }} (F3)</el-button
                    >
                    <el-button v-if="permission.scanConfirm" size="small" type="warning" class="search-btn" @click="scanComfirms()">{{ permission.scanConfirm }} (F4)</el-button>
                    <div v-if="permission.scanConfirm" class="search-name" style="color: red">（使用扫码确认功能请确保焦点在标签输入框内，并检查电脑的输入法是否英文输入）</div>
                </div>
                <div class="search-ctn-right" v-if="totalSummaryStr">
                    <div class="section-summary">
                        <div>
                            <span>{{ totalSummaryStr ? '合计：' + totalSummaryStr : '' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    highlight-current-row
                    style="width: 100%"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border=""
                    :data="tableData"
                    height="500"
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :row-class-name="tableRowClassName"
                    :tableCode="tableCode"
                    @row-click="rowClick"
                    :row-key="getRowKeys"
                    @sort-change="sortChange"
                    v-el-table-infinite-scroll="tableLoad"
                >
                    <el-table-column type="selection" width="50" reserve-selection :selectable="selectInit"></el-table-column>
                    <template v-for="(col,index) in columnShowSets">
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'OrderCode'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <img src="@/assets/images/union.png" title="联盟订单" style="width: 20px; height: 20px; margin-right: 3px" v-if="scope.row.IsUnionOrder" />
                                <img src="@/assets/images/agent.png" title="联盟代发对账单" style="width: 20px; height: 20px" v-if="scope.row.IsMyAgentOrder" />
                                {{ scope.row.OrderCode }}
                                <img
                                    v-show="scope.row.OrderId"
                                    src="@/assets/images/preview.png"
                                    title="打印预览"
                                    style="margin-left: 5px; width: 24px; height: 24px"
                                    @click.stop="viewOrderDetail(scope.row.OrderType, scope.row.OrderId, scope.row.OrderCode)"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'InWarehouseStateName'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">
                                <i v-if="scope.row.IsAllNotOut || scope.row.IsMyAgentOrder" class="out-active">不需入仓</i>
                                <i v-else-if="scope.row.IsDelivery" class="out-active">已入仓</i>
                                <i v-else>未入仓</i>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OrderType'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <i v-if="scope.row.OrderType == 0" class="c-active">采购付款</i>
                                <i v-else class="out-active">采购退货</i>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'ConfirmStateName'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">
                                <i v-if="scope.row.IsCanStateBack" class="confirm-active">{{ scope.row.ConfirmStateName }}</i>
                                <i v-else>{{ scope.row.ConfirmStateName }}</i>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OrderAmount'"
                            show-overflow-tooltip
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.OrderAmount : -scope.row.OrderAmount }}</template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'CalcAmount'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                {{
                                    (scope.row.OrderType == 0
                                        ? (scope.row.OrderAmount + scope.row.ShipAmount).toFixed(2)
                                        : -(scope.row.OrderAmount + scope.row.ShipAmount).toFixed(2))
                                        - scope.row.DiscountAmount.toFixed(2)
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </el-table-column>
                    </template>
                    <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <el-button
                                v-if="permission.confirm && !scope.row.IsCanStateBack && (scope.row.IsDelivery || scope.row.IsAllNotOut || scope.row.IsMyAgentOrder)"
                                :title="permission.confirm"
                                size="mini"
                                type="text"
                                @click.stop="confirm(scope.row)"
                                >{{ permission.confirm }}</el-button
                            >
                            <el-button
                                v-if="permission.stateBack && scope.row.IsCanStateBack && !scope.row.IsLock"
                                :title="permission.stateBack"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click.stop="stateBack(scope.row)"
                                >{{ permission.stateBack }}</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
                <div class="section-summary" v-if="isShowSummary">
                    <div>
                        <span>合计：{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
            <div class="section-title">
                <div>
                    <span>{{ !orderCode ? '' : '【' + orderCode + '】' }}订单明细</span>
                </div>
            </div>
            <div>
                <el-table
                    v-loading="loading"
                    class="detail-table"
                    :data="orderGoodsData"
                    style="width: 100%"
                    height="200px"
                    border=""
                    :header-cell-style="{ background: '#F2F6FC' }"
                >
                    <el-table-column prop="SortNum" label="序号" width="80"></el-table-column>
                    <el-table-column prop="APCode" label="汽配编码" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="GoodName" label="汽配名称" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="AutoSerise" label="车型" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Origin" label="产地" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Count" label="数量" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.Count : -scope.row.Count }}</template>
                    </el-table-column>
                    <el-table-column prop="Unit" label="单位" width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Price" label="采购价" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.Price.toFixed(2) : -scope.row.Price.toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column prop="PriceAmount" label="采购总价" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{
                            scope.row.OrderType == 0 ? (scope.row.Count * scope.row.Price).toFixed(2) : -(scope.row.Count * scope.row.Price).toFixed(2)
                        }}</template>
                    </el-table-column>
                    <el-table-column prop="WarehousedCount" label="已入库数" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.WarehousedCount : -scope.row.WarehousedCount }}</template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog
                :close-on-click-modal="false"
                title="入库单搜索"
                :visible.sync="dialogVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="供应商">
                            <el-select
                                ref="search_0"
                                class="search-item"
                                size="small"
                                style="width: 100%"
                                v-model="searchData.Keyword"
                                remote
                                filterable
                                clearable
                                placeholder="请输入供应商名称"
                                :remote-method="searchCustom"
                                v-select-scroll-more="searchCustomLoad"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="部门" v-if="isExObj('OrgName')">
                            <el-select
                                size="small"
                                class="search-item"
                                style="width: 100%"
                                v-model="searchData.OrgIds"
                                filterable
                                clearable
                                collapse-tags
                                reserve-keyword
                                multiple
                                @visible-change="orgVisibleChange($event)"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="optionItem in orgSearchData"
                                    :key="optionItem.Id"
                                    :data-msg="optionItem"
                                    :label="optionItem.Name"
                                    :value="optionItem.Id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单号" v-if="isExObj('OrderCode')">
                            <el-input
                                class="search-item"
                                style="width: 100%"
                                size="small"
                                v-model.trim="searchData.OrderCode"
                                v-filter-special-char="searchData.OrderCode"
                                placeholder="采购/退货单号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="入库仓库" v-if="isExObj('WarehouseName')">
                            <el-select size="small" style="width: 100%" v-model="searchData.WarehouseId" filterable clearable @visible-change="wHVisibleChange($event)">
                                <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                                    <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                    <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="支付方式" v-if="isExObj('PayTypeName')">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.PayType" multiple collapse-tags clearable>
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="物流状态" v-if="isExObj('InWarehouseStateName')">
                            <el-select ref="search_3" class="search-item" style="width: 100%" size="small" v-model="searchData.DeliveryState">
                                <el-option v-for="item in deliStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="确认状态" v-if="isExObj('ConfirmStateName')">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.State">
                                <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="单据类型" v-if="isExObj('OrderType')">
                            <el-select class="search-item" style="width: 100%" size="small" v-model="searchData.OrderType">
                                <el-option v-for="item in orderTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="采购员" v-if="isExObj('SName')">
                            <el-select v-model="searchData.SId" style="width: 100%" class="search-item" size="small" filterable clearable placeholder="请选择">
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="确认人" v-if="isExObj('Confirmer')">
                            <el-select v-model="searchData.ConfirmerId" style="width: 100%" class="search-item" size="small" filterable clearable placeholder="请选择">
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate1TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="确认日期" v-if="isExObj('ConfirmTime')">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime2"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate2TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="提交日期" v-if="isExObj('SubmitTime')">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime3"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate3TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="入库日期" v-if="isExObj('WHFinishTime')">
                            <el-date-picker
                                size="small"
                                style="width: 100%"
                                v-model="datetime4"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                @change="onDate4TimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="查询公式">
                            <el-radio-group v-model="searchData.SearchType">
                                <el-radio :label="0">左等</el-radio>
                                <el-radio :label="1">全等</el-radio>
                                <el-radio :label="2">包含</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                title="扫码确认"
                :visible.sync="dialogScanVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="scan-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogScanVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="单号">
                            <el-input
                                class="search-name"
                                ref="inputdata"
                                v-model="scanData"
                                clearable
                                placeholder="请扫描采购单或退货单二维码"
                                size="small"
                                style="width: 250px"
                                @blur="inputblur()"
                                @change="inputDataChange()"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="确认单据" :visible.sync="confirmVisible" width="1000px">
                <div class="dialog-content" v-if="confirmVisible">
                    <ConfirmPay ref="confirmPay" @closeConfirm="closeConfirm(arguments)" :confirmData="currentRow" :type="0"></ConfirmPay>
                </div>
            </el-dialog>
            <el-dialog
                :close-on-click-modal="false"
                title="批量确认"
                :visible.sync="dialogBacthVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="scan-dc-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="dialogBacthVisible">
                    <el-form ref="form" label-position="left" label-width="70px">
                        <el-form-item label="支付方式">
                            <el-select ref="confirm_0" class="search-item" style="width: 100%" size="small" v-model="subPaytype">
                                <el-option v-for="item in payWayList_batch" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button size="small" @click="closeBacthConfirm()">关闭（Esc）</el-button>
                        <el-button class="btn-primary" size="small" @click="handleBacthSubmit">提交（Enter）</el-button>
                    </div>
                </div>
            </el-dialog>
            <!--  打印  -->
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printDialogVisible" width="870px">
                <div class="dialog-content" v-if="printDialogVisible">
                    <printHKStockInConfirms @closeDialog="closePrintDialog" :sParams="searchParams" :isInit="true"></printHKStockInConfirms>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printOrderPreview" width="870px">
                <div class="dialog-content" v-if="printOrderPreview">
                    <printContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :canPrint="true" :isInit="true"></printContent>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printReturnPreview" width="870px">
                <div class="dialog-content" v-if="printReturnPreview">
                    <printReturnContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :isInit="true"></printReturnContent>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import ConfirmPay from '@/components/business/revenue_h/confirmInOrder';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import printHKStockInConfirms from '@/components/printModels/printHKStockInConfirms';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        ConfirmPay,
        printHKStockInConfirms
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                    this.searchIndex = 0;
                });
            }
        },
        tableData() {
            this.doLayout();
        }
    },
    data() {
        return {
            searchIndex: 0,
            isStartSearch: false,
            summaryStr: '',
            totalSummaryStr: '',
            orderCode: '',
            datetime1: [],
            datetime2: [],
            datetime3: [],
            datetime4: [],
            orgSearchData: [],
            loading: '',
            tableCode: 'InStorageConfirms_H',
            multipleSelection: null,
            dialogVisible: false,
            dialogScanVisible: false,
            firstScanOrder: true,
            confirmVisible: false,
            scanData: '',
            dataindex: 0,
            stopFresh: false,
            stopRequest: false,
            isShowSummary: false,
            dialogBacthVisible: false,
            subPaytype: '',
            searchData: {
                State: '',
                PayType: [],
                Keyword: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                ConfirmerId: '',
                SortProp: '',
                SortType: '',
                OrderType: '',
                DeliveryState: '',
                CusId: '',
                SId: '',
                WarehouseId: '',
                OrgIds: [],
                SearchType:2,
                page: 1,
                limit: this.commonPageSize
            },
            searchParams: {},
            currentRow: {},
            tableData: [],
            orderGoodsData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未确认', Value: '0' },
                { Text: '已确认', Value: '1' }
            ],
            orderTypeList: [
                { Text: '全部', Value: '' },
                { Text: '采购单', Value: '0' },
                { Text: '采购退货单', Value: '1' }
            ],
            deliStateList: [
                { Text: '全部', Value: '' },
                { Text: '未入仓', Value: '0' },
                { Text: '已入仓', Value: '1' },
                { Text: '不需入仓', Value: '2' }
            ],
            SIdList: [],
            payWayList: [],
            payWayList_batch: [],
            idList: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            columnShowSets: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            printDialogVisible: false,
            printOrderPreview: false,
            printReturnPreview: false,
            warehouseList: [],
            isDefaultSet: false
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        let that = this;
        if (that.tableCode) {
            that.getSetsData().then(() => {
                //当前设定的日期时间
                let d = new Date();
                let year1, month1, day1;
                [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                let date1 = new Date(year1, month1, day1, 0);

                //前一天设定的日期时间
                let year2, month2, day2;
                d.setTime(d.getTime());
                [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                let date2 = new Date(year2, month2, day2, 0);

                if (that.isExObj('SubmitTime')) { 
                    that.datetime3.push(date1);
                    that.datetime3.unshift(date2);

                    that.searchData.CStartDate = date2;
                    that.searchData.CEndDate = date1;
                } else if (that.isExObj('CreateTime')) {
                    that.datetime1.push(date1);
                    that.datetime1.unshift(date2);

                    that.searchData.StartDate = date2;
                    that.searchData.EndDate = date1;
                }

                this.permission = this.$util.getPermission('StockInConfirms_H');
                this.getTableData();
                that.getConfigByCodes().then(() => {
                    that.initSearchSelectData();
                    that.getPrintComponents();
                });
            });
        }
    },
    mounted() {},
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            //F2
            if (key === 113) {
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            //F3
            if (key === 114) {
                that.batchComfirms();
            }
            //F4
            if (key === 115) {
                that.scanComfirms();
            }
            if (key === 13) {
                if (!that.dialogScanVisible) {
                    if (that.dialogBacthVisible) {
                        that.$refs.confirm_0.blur();
                        that.handleBacthSubmit();
                    } else {
                        if (that.dialogVisible) {
                            that.handleSearch();
                            that.isStartSearch = false;
                        } else if (!that.confirmVisible) {
                            if (that.currentRow && (that.currentRow.IsDelivery || that.currentRow.IsAllNotOut || that.currentRow.IsMyAgentOrder)) {
                                if (that.currentRow.OrderId && !that.currentRow.IsCanStateBack && !that.currentRow.IsCanStateBack) that.confirmVisible = true;
                            } else {
                                that.$util.warningMsg('订单还未入仓，请待入仓后再进行确认');
                                return;
                            }
                        } else if (that.confirmVisible) {
                            if (that.$refs.confirmPay) {
                                that.$refs.confirmPay.submitForm();
                            }
                        }
                    }
                }
            }
            //ESC
            if (key === 27) {
                if (that.dialogVisible) that.dialogVisible = false;
                else if (that.confirmVisible) that.confirmVisible = false;
                else if (that.dialogBacthVisible) that.dialogBacthVisible = false;
                else if (that.dialogScanVisible) that.dialogScanVisible = false;
            }
            //下键
            if (key == 40) {
                if (that.dataindex != that.tableData.length - 1) {
                    if (that.currentRow && that.currentRow.OrderId) {
                        that.dataindex++;
                    } else that.dataindex = 0;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.currentRow);
                            that.getOrderDetail();
                        }
                    });
                }
            }
            //上键
            if (key == 38) {
                if (that.dataindex != 0) {
                    that.dataindex--;
                    let index = that.dataindex;
                    that.$nextTick(() => {
                        if (that.$refs.multipleTable) {
                            that.currentRow = that.$refs.multipleTable.data[index];
                            that.$refs.multipleTable.setCurrentRow(that.currentRow);
                            that.getOrderDetail();
                        }
                    });
                }
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'syllqdysz': //是否使用浏览器打印
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        tableLoad() {
            if (!this.stopFresh && this.firstScanOrder && this.tableData && this.tableData.length > 0) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
            this.getOrderDetail();
        },
        getOrderDetail() {
            let item = this.currentRow;
            if (item) {
                this.orderCode = item.OrderCode;
                this.loading = true;
                let url = '';
                if (item.OrderType == 0) url = '/api/EntpPurchaseOrder/GetEntpPurOrderOnlyGoodsListById';
                else url = '/api/EntpPurReturnOrder/GetEntpSupReturnOrderGoodsListById';
                this.$util
                    .axiosGet({
                        url: url,
                        data: {
                            OrderId: item.OrderId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            this.orderGoodsData = res.data;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        // 供应商名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getPay();
            this.getSIdList();
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
                this.payWayList_batch = [...data];
            });
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            if (val.length > 0) {
                this.isShowSummary = true;
                let pa = 0; //采购总额
                let pahj = 0; //合计
                let yf = 0;
                let sfhj = 0; //实付总合计
                for (let i = 0; i < val.length; i++) {
                    idList.push(val[i].OrderId);
                    let oa = val[i].OrderAmount;
                    let ss = val[i].Paid;
                    if (val[i].OrderType == 0) {
                        pa += oa;
                        pahj += val[i].OrderAmount + val[i].ShipAmount;
                        if (val[i].IsCanStateBack) sfhj += ss;
                    } else {
                        pa -= oa;
                        pahj -= oa;
                        if (val[i].IsCanStateBack) sfhj -= ss;
                    }
                    yf += val[i].ShipAmount;
                }

                this.summaryStr = '采购总额 = ' + pa.toFixed(2) + '；  运费总额 = ' + yf.toFixed(2) + '；  总合计 = ' + pahj.toFixed(2) + '；  实付总金额 = ' + sfhj.toFixed(2);

                this.idList = idList;
            }
        },
        resetSearch() {
            this.searchData = {
                State: '',
                PayType: [],
                Keyword: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                ConfirmerId: '',
                SortProp: '',
                SortType: '',
                OrderType: '',
                CusId: '',
                SId: '',
                WarehouseId: '',
                OrgIds: [],
                SearchType:2,
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime1 = [];
            this.datetime2 = [];
            this.datetime3 = [];
            this.datetime4 = [];
            // this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            let that = this;
            if (!that.stopRequest) {
                if (that.searchData.page == 1) {
                    that.searchParams = { ...that.searchData };
                    that.tableData = [];
                } else {
                    that.searchParams.page = that.searchData.page;
                }
                if (that.searchData.Keyword) that.searchData.CusId = '';
                that.stopFresh = true;
                that.stopRequest = true;
                that.$util
                    .axiosPost({
                        // url: '/api/RevenueManagement_H/GetSupOrdersConfirmList',
                        url: '/api/RevenueManagement_H/GetSupOrdersConfirmList_New',
                        data: that.searchParams
                    })
                    .then(res => {
                        let data = res.data;
                        if (res.errcode != 201) {
                            if (that.searchData.page == 1) {
                                that.tableData = [];
                                that.tableDataLength = 0;
                                that.totalSummaryStr ="共合计0 项； 订单总额：0.00";
                                that.searchParams.total =0;
                                if(data&&data.DataList.length>0)
                                    that.getOtherData();
                            }
                            let list = [...that.tableData, ...data.DataList];
                            const maps = new Map();
                            list = list.filter(m => !maps.has(m.OrderId) && maps.set(m.OrderId, 1));
                            that.tableData = list;
                            that.stopFresh = data.DataList.length < that.searchData.limit;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        that.stopRequest = false;
                    });
            }
        },
        getOtherData() {
            let that = this;
            that.$util
                .axiosPost({
                    // url: '/api/RevenueManagement_H/GetSupOrdersConfirmOtherData',
                    url: '/api/RevenueManagement_H/GetSupOrdersConfirmOtherData_New',
                    data: that.searchParams,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (res.errcode != 201) {
                        if (that.searchData.page == 1) {
                            that.tableDataLength = data.total;
                            that.totalSummaryStr = data.SummaryStr;
                            that.searchParams.total = data.Total;
                        }
                    }
                })
                .catch(() => {});
        },
        handleSearch() {
            this.dataindex = 0;
            this.firstScanOrder = true;
            this.idList = [];
            if (this.$refs.multipleTable) this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        stateBack(item) {
            let that = this;
            if (!that.dialogScanVisible) {
                if (item.OrderId) {
                    that.$confirm('您确定要将该确认状态回退到未确认状态吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            //预留批量回退的功能，但目前的业务可能不做
                            let ids = [];
                            ids.push(item.OrderId);
                            that.$util
                                .axiosPost({
                                    url: '/api/RevenueManagement_H/PurConfirmStateBack',
                                    data: {
                                        OrderIds: ids
                                    }
                                })
                                .then(res => {
                                    that.$util.successMsg('状态回退成功');
                                    //that.handleSearch();
                                    that.tableData.forEach(item => {
                                        that.$refs.multipleTable.toggleRowSelection(item, false);
                                        var index = ids.findIndex(f => f === item.OrderId);
                                        if (index > -1) {
                                            item.IsCanStateBack = false;
                                            item.ConfirmStateName = '未确认';
                                        }
                                    });
                                })
                                .catch(() => {});
                        })
                        .catch(() => {});
                } else {
                    that.$util.warningMsg('订单信息异常，请刷新后重新操作');
                }
            } else {
                that.$util.warningMsg('请先关闭扫码窗口');
            }
        },
        confirm(item) {
            let that = this;
            if (item.IsDelivery || item.IsAllNotOut || item.IsMyAgentOrder) {
                if (!that.dialogScanVisible) {
                    if (item.OrderId) {
                        this.currentRow = item;
                        this.confirmVisible = true;
                    } else {
                        that.$util.warningMsg('订单信息异常，请刷新后重新操作');
                    }
                } else {
                    that.$util.warningMsg('请先关闭扫码窗口');
                }
            } else {
                that.$util.warningMsg('订单还未入仓，请待入仓后再进行确认');
            }
        },
        batchComfirms() {
            let that = this;
            if (that.idList.length > 0) {
                that.dialogBacthVisible = true;
                that.dialogScanVisible = false;
            } else {
                that.$util.warningMsg('请先勾选订单再进行批量确认操作');
            }
        },
        confirmOrder(ids) {
            let that = this;
            if (ids && ids.length > 0) {
                if(!that.stopConfirm){
                    that.stopConfirm = true;
                    that.$util
                    .axiosPost({
                        url: '/api/RevenueManagement_H/ConfirmPurOrders',
                        data: {
                            OrderIds: ids,
                            PayType: that.subPaytype
                        }
                    })
                    .then(res => {
                        that.firstScanOrder = true;
                        if (that.dialogBacthVisible) that.dialogBacthVisible = false;
                        that.$util.successMsg('单据确认成功');
                        // that.handleSearch();
                        let _PayTypeName = that.payWayList_batch[that.payWayList_batch.findIndex(f => f.Value === that.subPaytype)].Text;
                        let _Confirmer = that.$util.getLocalStorage('userMsg').EmployeeName;
                        let _ConfirmTime = that.$util.formatDate(new Date().getTime());
                        that.tableData.forEach(item => {
                            that.$refs.multipleTable.toggleRowSelection(item, false);
                            var index = ids.findIndex(f => f === item.OrderId);
                            if (index > -1) {
                                item.IsCanStateBack = true;
                                item.ConfirmStateName = '已确认';
                                item.PayTypeName = _PayTypeName;
                                item.Confirmer = _Confirmer;
                                item.ConfirmTime = _ConfirmTime;
                            }
                        });
                        that.idList = [];
                        that.firstScanOrder = true;
                    })
                    .catch(() => {})
                    .finally(() => {
                        that.stopConfirm = false;
                    });
                    } else that.$util.warningMsg('请勿重新提交');
            } else {
                that.$util.warningMsg('订单信息异常，请刷新后重新操作');
            }
        },

        getSetsData() {
            let that = this;
            return new Promise(resolve => {
                this.columnShowSets = [];
                this.$util
                    .getTBSetsForShow(this.tableCode)
                    .then(data => {
                        data.forEach(item => {
                            let colums = {
                                IsShow: item.IsShow,
                                Width: item.Width,
                                ColumnName: item.ColumnName,
                                ColumnCode: item.ColumnCode,
                                SortNum: item.SortNum,
                                IsSort: item.IsSort
                            };

                            this.columnShowSets.push(colums);
                            resolve();
                        });
                    })
                    .catch(res => {
                        resolve(res);
                    });
            });
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgSearchData.length == 0)
                    that.$util.getParentOrgs().then(data => {
                        that.orgSearchData = data;
                    });
            }
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        onDate4TimeSelect(val) {
            if (val != null) {
                this.searchData.WStartDate = val[0];
                this.searchData.WEndDate = val[1];
            } else {
                this.searchData.WStartDate = '';
                this.searchData.WEndDate = '';
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.tableData = [];
            this.getTableData();
        },
        scanComfirms() {
            this.dialogScanVisible = true;
            this.inputblur();
        },
        // 失去焦点
        inputblur() {
            let that = this;
            // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
            that.$nextTick(() => {
                if (that.$refs.inputdata) that.$refs.inputdata.focus();
            });
        },
        inputDataChange() {
            let that = this;
            that.resetSearch();
            that.scanData = that.scanData.trim();
            if (that.scanData.indexOf('CG') > -1) {
                that.searchData.OrderCode = that.scanData;
                if (that.scanData.length == 17) {

                    let order = that.tableData.findIndex(x=>x.OrderCode == that.scanData);
                    if(!that.firstScanOrder && order > -1){
                        that.$util.warningMsg('已扫入重复单号【'+that.scanData+'】');
                        that.scanData = "";
                        return false;
                    }
                    if (that.firstScanOrder) {
                        that.tableData = [];
                    }
                    that.firstScanOrder = false;
                    that.$util
                        .axiosGet({
                            // url: '/api/RevenueManagement_H/GetSupConfirmOrderByScan',
                            url: '/api/RevenueManagement_H/GetSupConfirmOrderByScan_New',
                            data: { orderCode: that.scanData }
                        })
                        .then(res => {
                            let data = res.data;
                            if (!data) {
                                that.$util.warningMsg('未检测到相应的单据');
                                return;
                            } else {
                                that.tableData.push(data);
                            }
                            let list = that.tableData;
                            const maps = new Map();
                            list = list.filter(m => !maps.has(m.OrderId) && maps.set(m.OrderId, 1));
                            //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                            that.tableData = list.reverse();
                            that.$nextTick(() => {
                                that.tableData.forEach(row => {
                                    that.$refs.multipleTable.toggleRowSelection(row, true);
                                });
                            });
                        });
                } else if (that.scanData.indexOf('CGTH') > -1 && that.scanData.length == 19) {
                    let order = that.tableData.findIndex(x=>x.OrderCode == that.scanData);
                    if(!that.firstScanOrder && order > -1){
                        that.$util.warningMsg('已扫入重复单号【'+that.scanData+'】');
                        that.scanData = "";
                        return false;
                    }
                    if (that.firstScanOrder) {
                        that.tableData = [];
                    }
                    that.firstScanOrder = false;
                    that.$util
                        .axiosGet({
                            // url: '/api/RevenueManagement_H/GetSupConfirmOrderByScan',
                            url: '/api/RevenueManagement_H/GetSupConfirmOrderByScan_New',
                            data: { orderCode: that.scanData }
                        })
                        .then(res => {
                            let data = res.data;
                            if (!data) {
                                that.$util.warningMsg('未检测到相应的单据');
                                return;
                            } else {
                                that.tableData.push(data);
                            }
                            let list = that.tableData;
                            const maps = new Map();
                            list = list.filter(m => !maps.has(m.OrderId) && maps.set(m.OrderId, 1));
                            that.tableData = list.reverse();
                            that.$nextTick(() => {
                                that.tableData.forEach(row => {
                                    that.$refs.multipleTable.toggleRowSelection(row, true);
                                });
                            });
                        });
                } else {
                    that.$util.warningMsg('采购单号/退货单号长度不符合规则！');
                }
            } else if (that.scanData.length == 36) {
                //当前设定的日期时间
                let d = new Date();
                let year1, month1, day1;
                [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                let date1 = new Date(year1, month1, day1, 0);

                //前一天设定的日期时间
                let year2, month2, day2;
                d.setTime(d.getTime());
                [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                let date2 = new Date(year2, month2, day2, 0);

                if (that.isExObj('SubmitTime')) { 
                    that.datetime3.push(date1);
                    that.datetime3.unshift(date2);

                    that.searchData.CStartDate = date2;
                    that.searchData.CEndDate = date1;
                } else if (that.isExObj('CreateTime')) {
                    that.datetime1.push(date1);
                    that.datetime1.unshift(date2);

                    that.searchData.StartDate = date2;
                    that.searchData.EndDate = date1;
                }
                that.searchData.CusId = that.scanData;

                that.tableData = [];
                that.$util
                    .axiosPost({
                        // url: '/api/RevenueManagement_H/GetSupOrdersConfirmList',
                        url: '/api/RevenueManagement_H/GetSupOrdersConfirmList_New',
                        data: that.searchData
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) {
                            return;
                        }
                        that.tableData = data.DataList;
                        that.totalSummaryStr = data.SummaryStr;
                    });
            }
            that.scanData = '';
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.OrderId;
        },
        closeConfirm(args) {
            this.confirmVisible = false;
            if (args && args.length > 0) {
                let that = this;
                that.tableData.forEach(item => {
                    if (item.OrderId == that.currentRow.OrderId) {
                        item.IsCanStateBack = true;
                        item.ConfirmStateName = '已确认';
                        if (args[0]) {
                            item.PayTypeName = args[0].PayName;
                            item.Confirmer = args[0].UserName;
                            item.ConfirmTime = args[0].ConfirmTime;
                        }
                        if (args[1]) item.Paid = +args[1];
                        return;
                    }
                });
            }
        },
        selectInit(row, index) {
            //如果没有选中，要开放全部选择
            if (row.IsCanStateBack || (!row.IsDelivery && !row.IsAllNotOut && !row.IsMyAgentOrder)) return false;
            else return true;
        },
        handleBacthSubmit() {
            let that = this;
            if (!that.subPaytype) {
                that.$util.warningMsg('请先选择支付方式，再进行批量确认提交操作');
                return;
            }
            that.$confirm('您确定要将选中数据进行批量确认吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            })
                .then(() => {
                    that.confirmOrder(that.idList);
                })
                .catch(() => {});
        },
        closeBacthConfirm() {
            this.dialogBacthVisible = false;
            this.subPaytype = '';
        },
        // 打印预览
        print() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }
            if (this.tableData.length == 0) {
                this.$util.warningMsg('请选择单据');
                return;
            }
            this.printDialogVisible = true;
        },
        closePrintDialog() {
            this.printDialogVisible = false;
        },
        viewOrderDetail(orderType, orderId, orderCode) {
            if (orderId) {
                if (orderType == 0) {
                    this.idList.push({
                        id: orderId,
                        orderCode: orderCode
                    });
                    this.printOrderPreview = true;
                } else if (orderType == 1) {
                    this.idList.push({
                        PReturnId: orderId
                    });
                    this.printReturnPreview = true;
                }
            } else {
                this.$util.warningMsg('要打印的订单异常，请刷新后重新操作');
            }
        },
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents(1).then(data => {
                if (data) {
                    Vue.component('printContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printContent', () => import('@/components/printModels/printPurchases'));
                }
            });

            that.$util.getPrintComponents(5).then(data => {
                if (data) {
                    Vue.component('printReturnContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printReturnContent', () => import('@/components/printModels/printPurReturn'));
                }
            });
        },
        closeOrderPrintDialog() {
            this.printOrderPreview = false;
            this.printReturnPreview = false;
            this.idList = [];
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouse(1).then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
         // 重新渲染table组件，用于处理刷新页面后配置 fixed="right" 的列出现样式错误的问题
        doLayout() {
            this.$nextTick(() => {
             setTimeout(() => {
                  this.$refs.multipleTable.doLayout();
                }, 100);  
            });
        },           
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 12.5%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
#search-dc-dialog,
#scan-dc-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.v-content {
    width: 100%;
    height: calc(100vh);
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.table-ctn {
    margin-bottom: 10px;
}
</style>
<style lang="less">
.outconfirm-content {
    .el-table {
        margin-bottom: 0px;

        th {
            padding: 4px 0;
        }
    }
    .detail-table {
        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 2px 0;
                }
            }
        }
    }
}
</style>
